// 2026-06-18 - FormuLearning - Step 1 패널 수집 중 플레이스홀더
// 파일 위치: frontend/src/features/step1/Collecting.tsx
// 점진적 표시(이슈 #4): 아직 채워지지 않은 패널에 '데이터 없음' 대신 수집 중 안내를 표시.

export default function Collecting({ label = 'Collecting information' }: { label?: string }) {
  return (
    <div className="flex items-center gap-1.5 text-[11px] text-text-secondary">
      <span>{label}</span>
      <span className="inline-flex gap-0.5">
        <span className="collecting-dot text-accent-purple">.</span>
        <span className="collecting-dot text-accent-purple">.</span>
        <span className="collecting-dot text-accent-purple">.</span>
      </span>
    </div>
  )
}
